import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

export const PayNearMe = (props) => {

    const initializePayNearMe = (token, paymentAmount) => {
        window.PNM.init({
            'order_token': token,
            "callback": callback,
            "target": "pnm-target",
            'auto_resize': true,
            'language': 'en',
            "header_size": "0",
            "header_bkgnd": "ffffff",
            "header_color": "ffffff",

            'actions': {
                'Pay': {
                    'action': 'pay',
                    'header': 'Make a Payment',
                    'debit': props.allowDebit,
                    'ach': props.allowAch,
                    'payment_amount': paymentAmount,
                    'display_receipt': true
                }
            },
        });
        window.PNM.launch('Pay');
    }

    useEffect(() => {
        const interval = setInterval(() => {
            if (window.PNM === undefined) {
                return;
            }

            initializePayNearMe(props.smartToken, props.paymentAmount);
            clearInterval(interval)
        }, 1000)

        return () => clearInterval(interval);

    }, [props.smartToken])

    useEffect(() => {

        const head = document.querySelector("head");
        const script = document.createElement("script");

        script.setAttribute("src", props.embeddedClientUrl);
        head.appendChild(script);

        return () => {
            head.removeChild(script);
        }

    }, []);

    const callback = (data) => {
        if (!data.status) {
            // status should always be present 
            // for any messages posted by the PNM iFrame.
            return;
        }

        if (data.status === 'error') {
            props.onMessage("PAYMENT_ERROR");
        }

        if (data.status === 'exit' ) {
            props.onMessage("PAYMENT_CANCEL");
        }

        if (data.status === 'complete') {
            props.onMessage("PAYMENT_SUCCESS");
        }
    };

    return (
        <div>
            <div id='pnm-target' style={{ display: 'flex', width: '740px', minHeight: '400px' }}></div>
        </div>
    )
}

PayNearMe.propTypes = {
    paymentAmount: PropTypes.number.isRequired, 
    embeddedClientUrl: PropTypes.string.isRequired, 
    smartToken: PropTypes.string.isRequired, 
    onMessage: PropTypes.func.isRequired, 
    allowDebit: PropTypes.boolean,
    allowAch: PropTypes.boolean
}

PayNearMe.defaultProps = {
    allowDebit: true,
    allowAch: true
}


// WEBPACK FOOTER //
// ./src/components/subcomponents/PayNearMe.jsx